import apiClient from '../apiClient';

class JobService {
  constructor(profile) {
    this.profile = profile;
  }

  toBackendFormat(data) {
    return {
      description: data.description,
      phone: data.phone,
      ...(data.referenceCode && { referenceCode: data.referenceCode })
    };
  }

  fromBackendFormat(doc) {
    if (!doc) return null;
    return {
      ...doc,
      isPublished: doc.isPublished === true || doc.isPublished === 'true',
      companyProfile: doc.companyId,
    };
  }

  async createJob(data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.post('/jobs', backendData);
    return this.fromBackendFormat(response);
  }

  async getAllJobs({ limit, cursor } = {}) {
    const params = new URLSearchParams();
    if (limit) params.set('limit', String(limit));
    if (cursor) params.set('cursor', cursor);
    const qs = params.toString();
    const response = await apiClient.get(`/jobs${qs ? `?${qs}` : ''}`);
    return {
      items: (response.items || []).map(doc => this.fromBackendFormat(doc)),
      nextCursor: response.nextCursor || null,
    };
  }

  async getJobById(jobId) {
    const response = await apiClient.get(`/jobs/${jobId}`);
    return this.fromBackendFormat(response);
  }

  async getJobApplyById(jobId) {
    const response = await apiClient.get(`/jobs/${jobId}/apply`);
    return this.fromBackendFormat(response);
  }

  async getJobsByCompany({ limit, cursor } = {}) {
    const params = new URLSearchParams();
    if (limit) params.set('limit', String(limit));
    if (cursor) params.set('cursor', cursor);
    const qs = params.toString();
    const response = await apiClient.get(`/jobs/company${qs ? `?${qs}` : ''}`);
    return {
      items: (response.items || []).map(doc => this.fromBackendFormat(doc)),
      nextCursor: response.nextCursor || null,
      totalCount: response.totalCount ?? null,
    };
  }

  async toggleJobPublication(jobId, isPublished) {
    const response = await apiClient.patch(`/jobs/${jobId}/publish`, { isPublished });
    return this.fromBackendFormat(response);
  }

  async getShortlistedApplicants(jobId) {
    const response = await apiClient.get(`/jobs/${jobId}/shortlist`);
    return response.shortlistedApplicants || [];
  }

  async addToShortlist(jobId, jobSeekerProfileId) {
    const response = await apiClient.post(`/jobs/${jobId}/shortlist`, { jobSeekerProfileId });
    return response.shortlistedApplicants || [];
  }

  async removeFromShortlist(jobId, jobSeekerProfileId) {
    const response = await apiClient.delete(`/jobs/${jobId}/shortlist/${jobSeekerProfileId}`);
    return response.shortlistedApplicants || [];
  }
}

export default JobService;
